// packages/app/src/scaffolder/MyCustomExtension/extensions.ts

/*
  This is where the magic happens and creates the custom field extension.

  Note that if you're writing extensions part of a separate plugin,
  then please use `plugin.provide` from there instead and export it part of your `plugin.ts` rather than re-using the `scaffolder.plugin`.
*/

import {
  scaffolderPlugin,
  createScaffolderFieldExtension,
} from '@zephyr-abl-tech/plugin-scaffolder';
import {
  addAdditionalSecurityExemptionValidation,
  AdditionalSecurityExemption,
} from './addAdditionalSecurityExemption';
import {
  BusinessUnitDropdown,
  businessUnitDropdownValidation,
} from './businessUnitDropdown';
import { CustomDatePicker, dateValidation } from './customDatePicker';
import {
  DepartmentDropdown,
  departmentropdownValidation,
} from './departmentDropdown';
import {
  ExistingRepoDropdown,
  existingRepoDropdownValidation,
} from './existingRepoDropdown';
import {
  ExistingRepoOnly,
  existingRepoOnlyValidation,
} from './existingRepoOnly';
import { NewRepoOnly, newRepoOnlyValidation } from './newRepoOnly';
import { PrFields, prFieldValidation } from './prField';
import {
  SecurityExceptionFormUI,
  securityExceptionFormValidation,
} from './securityExceptionFormUi';

import { SquadDropdown, squadValidation } from './squadDropdown';
import { TechdocsFolder } from './techdocsFolder';

export const CustomPRExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'prFields',
    component: PrFields,
    validation: prFieldValidation,
  }),
);

export const CustomExistingOnly = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'existingRepoOnly',
    component: ExistingRepoOnly,
    validation: existingRepoOnlyValidation,
  }),
);

export const SquadDropdownExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'squadDropdown',
    component: SquadDropdown,
    validation: squadValidation,
  }),
);

export const TechdocsFolderExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'techdocsFolder',
    component: TechdocsFolder,
  }),
);

export const NewRepoNameOnlyExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'newRepoOnly',
    component: NewRepoOnly,
    validation: newRepoOnlyValidation,
  }),
);

export const ExistingRepoDropdownExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'existingRepoDropdown',
    component: ExistingRepoDropdown,
    validation: existingRepoDropdownValidation,
  }),
);

export const BusinessUnitDropdownExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'businessUnitDropdown',
    component: BusinessUnitDropdown,
    validation: businessUnitDropdownValidation,
  }),
);

export const DepartmentDropdownExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'departmentDropdown',
    component: DepartmentDropdown,
    validation: departmentropdownValidation,
  }),
);

export const CustomDatePickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'customDatePicker',
    component: CustomDatePicker,
    validation: dateValidation,
  }),
);

export const SecurityExceptionForm = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'securityExceptionFormUi',
    component: SecurityExceptionFormUI,
    validation: securityExceptionFormValidation,
  }),
);

export const AddAdditionalSecurityExemptionExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'addAdditionalSecurityExemption',
    component: AdditionalSecurityExemption,
    validation: addAdditionalSecurityExemptionValidation,
  }),
);
